/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import styled from "styled-components";
import { Select } from "antd";
import { usStates } from "@/utils/usStates";
import { SvgArrowDown } from "@/assets/icons";
import { NoResults } from "../customs/NoResults";
import { RATypography } from "../customs";

export const RASelectUSStates = ({ title = "", error = "", "data-testid": dataTestId = null, ...props }) => {
	const options = useMemo(() => {
		return usStates.map((c) => {
			return {
				value: c.abbreviation,
				label: c.name,
			};
		});
	}, []);

	const handleFilterOptions = (inputValue, option) =>
		option.value?.toLowerCase()?.includes(inputValue?.toLowerCase()) ||
		option.label?.toLowerCase()?.includes(inputValue?.toLowerCase());

	return (
		<Wrapper>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}
			<StyledSelect
				showSearch
				options={options}
				size="large"
				placeholder="Select State"
				suffixIcon={<SvgArrowDown />}
				notFoundContent={<NoResults description="Oops! You don't have any data" />}
				dropdownRender={(originNode) => <DropdownRender>{originNode}</DropdownRender>}
				dropdownMatchSelectWidth={false}
				filterOption={handleFilterOptions}
				data-testid={dataTestId}
				{...props}
			/>
			{!!error && (
				<RATypography variant="body3" color="#BF1A2F" top="4px">
					{error}
				</RATypography>
			)}
		</Wrapper>
	);
};

const Wrapper = styled.div``;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;
const StyledSelect = styled(Select)`
	width: 100%;
	&.ant-select .ant-select-selector {
		font-family: "DM Sans";
		font-size: 14px !important;
		height: 44px;
		padding: 0 20px !important;
		border-radius: 12px;
	}
	.ant-select-selection-item {
		display: flex;
		align-items: center;
		color: #65686f;
		font-size: 14px !important;
		font-family: "DM Sans";
	}
	.ant-select-selection-search,
	.ant-select-selection-placeholder {
		display: flex;
		align-items: center;
		inset-inline-start: 20px !important;
		inset-inline-end: 40px !important;
		color: #a8a8a8;
	}
	.ant-select-arrow {
		inset-inline-end: 20px;
	}
	&.ant-select {
		height: 44px;
	}
	&.ant-select-sm {
		height: 32px;
	}
	&.ant-select-lg {
		height: 50px;
	}
	&.ant-select-lg .ant-select-selector {
		height: 50px !important;
	}
	&.ant-select-sm .ant-select-selector {
		height: 32px !important;
	}
	.ant-select-selection-placeholder {
		color: #a8a8a8;
		font-family: "DM Sans";
		font-size: 14px;
	}
`;
const DropdownRender = styled.div`
	.ant-select-item {
		height: 50px;
		padding: 0 20px;
		color: #65686f;
		font-family: DMSans-Medium;
		font-size: 14px;
		display: flex;
		align-items: center;
	}
`;
